import { Component, OnInit } from '@angular/core';

import { BreadCrumb } from '@nationwide/internet-servicing-angular-components';
import { PackageService } from 'app/commercial/claims/services/package.service';
import { PolicyInfoService } from 'app/commercial/claims/services/policy-info.service';
import { environment } from 'environments/environment';
import { LoggerService } from '../../../../shared/services/logger.service';
import { ClaimsDataService } from '../../services/claims-data.service';
import { CommercialLoggingService } from '../../services/commercial-logging.service';
import { SearchForClaimsService } from '../../services/search-for-claims.service';
@Component({
    selector: 'is-pak-claims-list',
    templateUrl: './pak-claims-list.component.html',
    styleUrls: ['./pak-claims-list.component.scss'],
    standalone: false
})
export class PAKClaimsListComponent implements OnInit {
    accountNumber: any;
    allClaimsList: any;
    breadCrumbs: BreadCrumb[] = [];
    claimNumber = '';
    currentPage = 'Package (PAK) Claims';
    homeIconLink = environment.NATIONWIDE.accountSummaryPage;
    isLoadComplete = false;
    package: any;
    pakNumber: any;

    constructor(
        public policyInfoService: PolicyInfoService,
        public claimsDataService: ClaimsDataService,
        private LOGGER: LoggerService,
        private searchClaimsService: SearchForClaimsService,
        private packageService: PackageService,
        private commercialLoggingService: CommercialLoggingService
    ) { }

    ngOnInit(): void {
        this.commercialLoggingService.logPageLoad(this.LOGGER, this.currentPage, this.getLogMetadata());
        this.claimsDataService.setFromSearch(false);
        const lookupIdentifier = this.claimsDataService.getClaimsLookupIdentifier();
        this.accountNumber = lookupIdentifier;

        this.packageService.retrievePackageDataforClaims(lookupIdentifier).subscribe((response) => {
            try {
                if (response && Object.keys(response).length > 0) {
                    this.package = response;
                    this.claimsDataService.hydratePackageContext(this.package);
                    this.accountNumber = this.claimsDataService.getClaimsAccountNumber();
                    this.claimsDataService.setClaimsPolicyType(this.getPolicyTypesString(this.package.policies));
                    this.retrieveClaimsList();
                } else {
                    this.package = {};
                    this.commercialLoggingService.logServiceFailure(
                        this.LOGGER,
                        this.currentPage,
                        'PackageService',
                        'retrievePackageDataforClaims',
                        this.getLogMetadata(),
                        { code: 'NO_PACKAGE_DATA' }
                    );
                }
            } catch (error) {
                this.package = {};
                this.commercialLoggingService.logServiceFailure(
                    this.LOGGER,
                    this.currentPage,
                    'PAKClaimsListComponent',
                    'mapPackageData',
                    this.getLogMetadata(),
                    error
                );
            }
        }, (error: any) => {
            this.package = {};
            this.commercialLoggingService.logServiceFailure(
                this.LOGGER,
                this.currentPage,
                'PackageService',
                'retrievePackageDataforClaims',
                this.getLogMetadata(),
                error
            );
        });
        this.commercialLoggingService.updatePreviousUrlContext();
    }

    retrieveClaimsList(): void {
        const showAllClaims = true;
        this.searchClaimsService.retrieveOpenClosedClaims(showAllClaims, this.claimsDataService.getClaimsAccountNumber()).then((response) => {
            this.allClaimsList = response;
            this.isLoadComplete = true;
        });
    }

    /**
     * Gets comma-separated policy types from package policies
     */
    private getPolicyTypesString(packageData: any): string {
        if (!packageData || !Array.isArray(packageData)) {
            return '';
        }

        const policyTypes = packageData
            .map((policy) => this.policyInfoService.getDisplayName(policy))
            .filter((type, index, self) => type && self.indexOf(type) === index);

        return policyTypes.join(', ');
    }

    private getLogMetadata(additionalFields: any = {}): any {
        return {
            policyNumber: this.claimsDataService.getClaimsPakNumber(),
            policyType: this.claimsDataService.getClaimsPolicyType(),
            lineOfBusiness: this.claimsDataService.getFnolFlow(),
            claimsDisplayCount: this.allClaimsList?.claimSummaries?.length || 'UNKNOWN',
            alphaState: this.claimsDataService.getPrimary(this.claimsDataService.getClaimsPackage()?.address)?.state || 'UNKNOWN',
            previousUrl: window.sessionStorage.getItem('previousUrl') || '',
            ...additionalFields
        };
    }
}
